import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import { Modal, Button, Paragraph, BottomSheet } from '@netexknowledge/smart-components';
import Media from 'react-media';
import { MOBILE_MEDIA_QUERY } from '../../../utils/mobileUtils';

class ArchiveClassroomReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.closeModal = this.closeModal.bind(this);
    this.handleArchiveClassroom = this.handleArchiveClassroom.bind(this);
  }

  static propTypes = {
    classroom: PropTypes.object
  };

  closeModal() {
    const { classroomActions } = this.props;
    classroomActions.setArchiveClassroomData();
  }

  handleArchiveClassroom() {
    const { classroom, classroomActions } = this.props;
    classroomActions.archiveClassroom(classroom.id);
    this.closeModal();
  }

  // Mobile: the same confirmation as a bottom sheet, naming the class being archived
  renderSheet() {
    const { classroom } = this.props;

    return (
      <BottomSheet
        open={!!classroom}
        onClose={this.closeModal}
        closeLabel={I18n.t('common.close')}
        title={I18n.t('classroom.archiveClassroom')}
        subtitle={classroom ? classroom.name : undefined}
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')} />
            <Button onClick={this.handleArchiveClassroom} primary label={I18n.t('common.option.archive')} />
          </>
        }
      >
        <p className="sheet-confirm-text">
          {I18n.t('classroom.archiveDisclaimer')} {I18n.t('common.uSure')}
        </p>
      </BottomSheet>
    );
  }

  render() {
    return <Media query={MOBILE_MEDIA_QUERY}>{isMobile => (isMobile ? this.renderSheet() : this.renderModal())}</Media>;
  }

  renderModal() {
    const { classroom } = this.props;

    return (
      <Modal
        id="archive-classroom"
        title={I18n.t('classroom.archiveClassroom')}
        active={!!classroom}
        onClickOutside={this.closeModal}
        children={
          <Paragraph className="text-grey-700">
            {I18n.t('classroom.archiveDisclaimer')} {I18n.t('common.uSure')}
          </Paragraph>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.handleArchiveClassroom} primary label={I18n.t('common.option.archive')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    classroom: state.classrooms.archiveModalClassroomData,
    colors: state.theme.colors,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveClassroomReveal);
